import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=a239cb02&"
import script from "./product_detail.vue?vue&type=script&lang=js&"
export * from "./product_detail.vue?vue&type=script&lang=js&"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=a239cb02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports